// Compact picker that pre-fills booking-form fields from the customer's
// saved travellers. Renders as a "chip strip" above any name input.
//
// Props:
//   onPick(traveller)  → callback invoked when the user taps a chip.
import React, { useEffect, useState } from 'react';
import { Users } from 'lucide-react';
import { api } from '../../lib/api';
import { useCustomerAuth } from '../../context/CustomerAuthContext';

const SavedTravellerPicker = ({ onPick }) => {
  const { customer } = useCustomerAuth();
  const [travellers, setTravellers] = useState([]);

  useEffect(() => {
    if (!customer) return;
    api.get('/customer/travellers')
      .then((r) => setTravellers(r.data.travellers || []))
      .catch(() => setTravellers([]));
  }, [customer]);

  if (!customer || travellers.length === 0) return null;

  return (
    <div className="mb-3" data-testid="saved-traveller-picker">
      <p className="text-[11px] uppercase tracking-wider text-gray-500 mb-1.5 flex items-center gap-1"><Users className="h-3 w-3" /> Auto-fill from saved travellers</p>
      <div className="flex flex-wrap gap-1.5">
        {travellers.map((t) => (
          <button
            key={t.id}
            type="button"
            data-testid={`saved-pick-${t.id}`}
            onClick={() => onPick(t)}
            className="text-xs px-2.5 py-1 rounded-full border border-red-200 bg-red-50/60 text-red-700 hover:bg-red-100 transition"
          >
            {t.full_name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SavedTravellerPicker;
